var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-tree" },
    [
      _vm.isUpdateFilter
        ? _c("custom-tree-group", {
            attrs: { data: _vm.data, change: _vm.onChange, isRoot: true },
            on: { deletechildren: _vm.deleteChildren },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }